var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-page" },
    [
      _c("div", { staticClass: "person-header primary white--text" }, [
        _c("div", { staticClass: "person-name-container" }, [
          _c(
            "div",
            { staticClass: "edit-name-header" },
            [
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "500" },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v("Continue with unsaved changes?")
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n              Are you sure you want to continue? Unsaved changes will be lost.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.continueWithUnsavedChanges()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Continue Anyways\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "red darken-1", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v("\n                Cancel\n              ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              (_vm.userIsSelected || _vm.userIsAdmin) && !_vm.editingName
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "white", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.changeEditing(_vm.startEditingName)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("edit")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editingName
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "white", outlined: "" },
                      on: {
                        click: function($event) {
                          return _vm.saveNameEdits()
                        }
                      }
                    },
                    [_vm._v("\n          Save\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editingName
                ? _c(
                    "v-btn",
                    {
                      style: { "margin-left": "20px" },
                      attrs: { color: "white", outlined: "" },
                      on: {
                        click: function($event) {
                          _vm.editingName = !_vm.editingName
                        }
                      }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "span",
                { staticClass: "person-name" },
                [
                  !_vm.editingName
                    ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.fName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editingName
                    ? _c("v-text-field", {
                        staticClass: "name-edit-text-field",
                        attrs: { "hide-details": "", dark: "", dense: "" },
                        model: {
                          value: _vm.nameFields["fName"],
                          callback: function($$v) {
                            _vm.$set(_vm.nameFields, "fName", $$v)
                          },
                          expression: "nameFields['fName']"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(" "))]),
                  _vm._v(" "),
                  !_vm.editingName
                    ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.lName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editingName
                    ? _c("v-text-field", {
                        staticClass: "name-edit-text-field",
                        attrs: { "hide-details": "", dark: "", dense: "" },
                        model: {
                          value: _vm.nameFields["lName"],
                          callback: function($$v) {
                            _vm.$set(_vm.nameFields, "lName", $$v)
                          },
                          expression: "nameFields['lName']"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPerson.nName
                    ? _c("span", [_vm._v(_vm._s(" ("))])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editingName
                    ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.nName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editingName
                    ? _c("v-text-field", {
                        staticClass: "name-edit-text-field",
                        attrs: { "hide-details": "", dark: "", dense: "" },
                        model: {
                          value: _vm.nameFields["nName"],
                          callback: function($$v) {
                            _vm.$set(_vm.nameFields, "nName", $$v)
                          },
                          expression: "nameFields['nName']"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPerson.nName
                    ? _c("span", [_vm._v(_vm._s(")"))])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              !_vm.editingName
                ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.group))])
                : _vm._e(),
              _vm._v(" "),
              _vm.editingName
                ? _c("v-text-field", {
                    staticClass: "name-edit-text-field",
                    attrs: { "hide-details": "", dark: "", dense: "" },
                    model: {
                      value: _vm.nameFields["group"],
                      callback: function($$v) {
                        _vm.$set(_vm.nameFields, "group", $$v)
                      },
                      expression: "nameFields['group']"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "profile-picture",
        attrs: { src: "https://cdn.vuetifyjs.com/images/cards/road.jpg" }
      }),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "user-info", attrs: { fluid: "", "grid-list-lg": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "tab-header",
                          attrs: {
                            color: "primary",
                            grow: "",
                            "slider-color": "primary"
                          },
                          model: {
                            value: _vm.currentItem,
                            callback: function($$v) {
                              _vm.currentItem = $$v
                            },
                            expression: "currentItem"
                          }
                        },
                        _vm._l(_vm.leftItems, function(item) {
                          return _c(
                            "v-tab",
                            { key: item, attrs: { href: "#tab-" + item } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.currentItem,
                            callback: function($$v) {
                              _vm.currentItem = $$v
                            },
                            expression: "currentItem"
                          }
                        },
                        _vm._l(_vm.leftItems, function(item) {
                          return _c(
                            "v-tab-item",
                            {
                              key: item,
                              staticClass: "tab-page",
                              attrs: { value: "tab-" + item }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-tab" },
                                [
                                  _vm.userIsAdmin && !_vm.editing[item]
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeEditing(
                                                _vm.startEditing,
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editing[item]
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            outlined: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.saveEdits(item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Save\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editing[item]
                                    ? _c(
                                        "v-btn",
                                        {
                                          style: { "margin-left": "20px" },
                                          attrs: {
                                            color: "primary",
                                            outlined: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.editing[item] = !_vm.editing[
                                                item
                                              ]
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Cancel\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    _vm._l(
                                      _vm.scopedItems(_vm.leftLayout[item]),
                                      function(field) {
                                        return _c(
                                          "div",
                                          { key: field.label },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-label" },
                                              [_vm._v(_vm._s(field.label))]
                                            ),
                                            _vm._v(" "),
                                            !_vm.editing[item]
                                              ? _c(
                                                  "div",
                                                  { staticClass: "field-data" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedPerson[
                                                          field.id
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.editing[item]
                                              ? _c("v-text-field", {
                                                  attrs: { label: field.label },
                                                  model: {
                                                    value:
                                                      _vm.editedItems[item][
                                                        field.id
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.editedItems[item],
                                                        field.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editedItems[item][field.id]"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-text", [
                        _c(
                          "div",
                          {
                            staticClass: "card-title flex-title primary--text"
                          },
                          [
                            _c("span", [_vm._v("Skills")]),
                            _vm._v(" "),
                            _vm.userIsSelected || _vm.userIsAdmin
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary--text",
                                    attrs: { to: "/skills", outlined: "" }
                                  },
                                  [_vm._v("Manage Skills")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-subtitle primary--text" },
                          [_vm._v("Level 3: Lead/Teach")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "unbulleted-list" },
                          _vm._l(_vm.selectedPersonSkillsRating3, function(
                            skill
                          ) {
                            return _c(
                              "li",
                              { key: skill.key, staticClass: "skill-li" },
                              [
                                skill.Name === "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "no-skills-label" },
                                      [_vm._v("None")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Name !== "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "skill-label" },
                                      [
                                        _c("v-img", {
                                          staticClass: "skill-image",
                                          attrs: {
                                            src: skill.ImageUrl,
                                            "max-width": "16pt"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(skill.Name) +
                                            "\n                "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Core === "TRUE"
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "core-icon",
                                        attrs: { color: "primary" }
                                      },
                                      [_vm._v("$jglogo")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-subtitle primary--text" },
                          [_vm._v("Level 2: Confident/Experienced")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "unbulleted-list" },
                          _vm._l(_vm.selectedPersonSkillsRating2, function(
                            skill
                          ) {
                            return _c(
                              "li",
                              { key: skill.key, staticClass: "skill-li" },
                              [
                                skill.Name === "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "no-skills-label" },
                                      [_vm._v("None")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Name !== "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "skill-label" },
                                      [
                                        _c("v-img", {
                                          staticClass: "skill-image",
                                          attrs: {
                                            src: skill.ImageUrl,
                                            "max-width": "16pt"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(skill.Name) +
                                            "\n                "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Core === "TRUE"
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "core-icon",
                                        attrs: { color: "primary" }
                                      },
                                      [_vm._v("$jglogo")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35d18db8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d18db8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/PersonPage.vue
// module id = Mk/W
// module chunks = 1